import React, { Component } from "react";
import {InputGroup, FormControl, Form, Button, Container} from "react-bootstrap";
import Ejercicio from "./ejercicio/ejercicio";
import { connect } from "react-redux";

import * as exerciseService from "../../../services/exercise";
import "./ejercicios.css";
import sync from "../../../assets/svg/sync.svg";

class Ejercicios extends Component {
  constructor(props) {
    super(props);
    this.state = {
      input: "",
      timeOut: null,
      utility: null,
      movement: null,
      apparatus: this.props.apparatus || [],
      musculo: this.props.musculo || null,
      showFilters: false,
    };
  }
  componentDidMount() {
    const filter = JSON.parse(localStorage.getItem('filter'))
    if (filter) {

      this.setState({
        movement: filter.movement,
        apparatus: filter.apparatus,
        musculo: filter.musculo,
        utility: filter.utility
      },() => {
        this.props.selectMusculo(
            filter.musculo,
            filter.apparatus,
            this.getFilter(filter.apparatus, filter.movement, filter.utility, filter.musculo)
        )
      })
      /*;*/
    }
  }

  reload() {
    window.location.reload();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      input: nextProps.musculo !== this.props.musculo ? "" : this.state.input,
    });
  }
  onUpdateInputHandler(name, value) {
    this.setState({ [name]: value });
  }
  onChangeHandler(e) {
    //console.log("change");
    this.setState({
      input: e.target.value,
    });
  }
  onSearch() {
    // console.log("time out");
    if (this.state.searchTimeOut) {
      clearTimeout(this.state.searchTimeOut);
      this.setState({ searchTimeOut: null });
    }
    this.setState({
      searchTimeOut: setTimeout(() => {
        // console.log("time out");
        this.props.onSearch(
          this.props.musculo,
          this.props.apparatus,
          this.getFilter()
        );
      }, 1000),
    });
  }
  groupOrPart(musculo) {
    const bodyPart = ['Shoulders','Forearms','Back','Chest','Waist','Hips','Calves'];
    // const muscleGroup = ['Triceps Brachii', 'Biceps Brachii','Abductors','Quadriceps','Hamstrings', 'Hip Adductors','Trapezius']
    if (bodyPart.indexOf(musculo) >= 0) return `bodypart=${musculo}&musclegroup=null`;
    return `bodypart=null&musclegroup=${musculo}`
  }
  getFilter(apparatus = null, movement = null, utility = null, musculo = null) {
    localStorage.setItem("filter",JSON.stringify({apparatus:apparatus ?? this.props.apparatus, movement, utility,musculo: musculo ?? this.props.musculo}))
    return `exercisename=${
      this.state.input === "" ? null : this.state.input
    }&${this.groupOrPart(musculo ?? this.props.musculo)}&apparatus=${
        apparatus ?? this.props.apparatus
    }&difficulty=null&utility_name=${utility}&movement_name=${movement}&apparatus_groups_name=null&mechanics=null&force=null&synergists=null&stabilizers=null&movement=null&subcategory=null&lang=es`;
  }

  isChecked(value) {
    return this.props.apparatus.indexOf(value) > 0;
  }
  changeMovement(e) {
    this.setState({
      movement: e.target.value != "null" ? e.target.value:null,
      showFilters: false
    });
    this.props.selectMusculo(
        this.props.musculo,
        this.props.apparatus,
        this.getFilter(this.props.apparatus, e.target.value != "null" ? e.target.value:null, this.state.utility)
    );
  }

  changeUtility(e) {
    this.setState({
      utility: e.target.value != "null" ? e.target.value:null,
      showFilters: false
    });
    this.props.selectMusculo(
        this.props.musculo,
        this.props.apparatus,
        this.getFilter(this.props.apparatus, this.state.movement, e.target.value != "null" ? e.target.value:null)
    );
  }

  changeMuscleGroup(e) {
    this.setState({
      musculo: e.target.value != "null" ? e.target.value:null,
      showFilters: false
    });
    this.props.selectMusculo(
        e.target.value != "null" ? e.target.value:null,
        this.props.apparatus,
        this.getFilter(this.props.apparatus, this.state.movement, this.state.utility,e.target.value != "null" ? e.target.value:null)
    );
  }

  changeApparatus(e) {
    const apparatus = this.state.apparatus;
    const index = apparatus.indexOf(e.target.value)
    if (index >= 0) apparatus.splice(index,1);
    else apparatus.push(e.target.value);
    this.setState({
      apparatus: apparatus,
      showFilters: false
    });
    this.props.selectMusculo(
        this.props.musculo,
        apparatus,
        this.getFilter(apparatus, this.state.movement, this.state.utility)
    );
  }
  changeName(musculo) {
    const names = {
      Chest: "Pectoral",
      Forearms: "Antebrazos",
      Back: "Espalda",
      Quadriceps: "Cuadriceps",
      Hamstrings: "Isquiosurales",
      Calves: "Pantorrillas",
      "Triceps Brachii": "Triceps",
      "Trapezius": "Trapecios",
      Shoulders: "Hombros",
      "Waist": "Abdominales",
      "Hips": "Gluteos",
      "Biceps Brachii": "Biceps",
      "Hip Adductors": "Aductores",
      Abductors: "Abductores",
    };
    return names[musculo];
  }
  isDisabled(equipament) {
    return (this.state.apparatus.indexOf(equipament) >= 0 && this.state.apparatus.length == 1) || (this.state.apparatus.indexOf(equipament) < 0 && this.state.apparatus.length == 3)
  }
  changeShowFilters() {
    this.setState({showFilters: !this.state.showFilters})
  }
  render() {
    return (
      <Container fluid="md" ref={this.props.listRef}>
        <div className="row header-ejercicios" style={{ padding: "0 15px", justifyContent: "space-between", alignItems: "center",flexWrap: 'wrap' }}>
          <div style={{display:"flex", alignItems:"center", width:"27rem", padding:'0px', marginBottom: '30px'}}>
            <h4 style={{margin:"0px"}}>
              Ejercicios de <span>{this.changeName(this.props.musculo)}</span>

            </h4>
            {/*<div className='btn-reload' onClick={()=>this.reload()} >
              <i className="fas fa-sync"></i>
            </div>*/}
          </div>

          <div style={{width:"15rem", padding:'0px', marginBottom: '30px'}}>
            <InputGroup>
              <FormControl
                  value={this.state.input}
                  onChange={this.onChangeHandler.bind(this)}
                  onInput={() => this.onSearch()}
                  placeholder="Buscar"
                  aria-label="Buscar"
                  aria-describedby="basic-addon2"
              />
            </InputGroup>
          </div>
        </div>
        <Container fluid={"md"}
          className="content-ejercicios"
          style={{ marginBottom: "40px" }}
        >
          <div >
            <Button className={"btn-filter"} onClick={()=>this.changeShowFilters()}>
              <i className={"fas fa-filter"}></i> Filtros

            </Button>
          </div>

          {this.state.showFilters ?<div id="hider"></div>:null}
          <div className="row" style={{alignItems: 'flex-start'}}>
            <div className={`col-12 col-lg-2 filters ${this.state.showFilters ? 'show':'hide'}`}>
              <div className={"list"}>
              <p><b>Grupo muscular</b></p>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Chest"} label="Pectoral" name="musculo" value="Chest" type="radio" id="musculo-1"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Forearms"} label="Antebrazos" name="musculo" value="Forearms" type="radio" id="musculo-2"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Back"} label="Espalda" name="musculo" value="Back" type="radio" id="musculo-3"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Quadriceps"} label="Cuadriceps" name="musculo" value="Quadriceps" type="radio" id="musculo-4"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Hamstrings"} label="Isquiosurales" name="musculo" value="Hamstrings" type="radio" id="musculo-5"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Calves"} label="Pantorrillas" name="musculo" value="Calves" type="radio" id="musculo-6"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Triceps"} label="Triceps" name="musculo" value="Triceps" type="radio" id="musculo-7"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Trapezius"} label="Trapecios" name="Trapezius" value="Trapezius" type="radio" id="musculo-8"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Shoulders"} label="Hombros" name="musculo" value="Shoulders" type="radio" id="musculo-9"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Waist"} label="Abdominales" name="musculo" value="Waist" type="radio" id="musculo-10"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Hips"} label="Gluteos" name="musculo" value="Hips" type="radio" id="musculo-11"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Biceps Brachii"} label="Biceps" name="musculo" value="Biceps Brachii" type="radio" id="musculo-12"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Hip Adductors"} label="Aductores" name="musculo" value="Hip Adductors" type="radio" id="musculo-13"/>
                <Form.Check onChange={this.changeMuscleGroup.bind(this)} checked={this.state.musculo === "Abductors"} label="Abductores" name="musculo" value="Abductors" type="radio" id="musculo-14"/>
              </div>
              <Form className={"list"}>
              <p><b>Implementos</b></p>
                <Form.Check disabled={this.isDisabled("Assisted")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Assisted")} label="Asistido" name="implements" value="Assisted" type="checkbox" id="implement-1"/>
                <Form.Check disabled={this.isDisabled("Barbell")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Barbell")} label="Barra" name="implements" value="Barbell" type="checkbox" id="implement-2"/>
                <Form.Check disabled={this.isDisabled("Cable")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Cable")} label="Polea" name="implements" value="Cable" type="checkbox" id="implement-3"/>
                <Form.Check disabled={this.isDisabled("Dumbbell")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Dumbbell")} label="Mancuerna" name="implements" value="Dumbbell" type="checkbox" id="implement-4"/>
                <Form.Check disabled={this.isDisabled("Lever")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Lever")} label="Máquina con discos" name="implements" value="Lever" type="checkbox" id="implement-5"/>
                <Form.Check disabled={this.isDisabled("Sled")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Sled")} label="Trineo" name="implements" value="Sled" type="checkbox" id="implement-6"/>
                <Form.Check disabled={this.isDisabled("Smith")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Smith")} label="Máquina Smith" name="implements" value="Smith" type="checkbox" id="implement-7"/>
                <Form.Check disabled={this.isDisabled("Weighted")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Weighted")} label="Lastre" name="implements" value="Weighted" type="checkbox" id="implement-8"/>
                <Form.Check disabled={this.isDisabled("Band-assisted")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Band-assisted")} label="Asistido con bandas" name="implements" value="Band-assisted" type="checkbox" id="implement-9"/>
                <Form.Check disabled={this.isDisabled("BodyWeight")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("BodyWeight")} label="Peso corporal" name="implements" value="BodyWeight" type="checkbox" id="implement-10"/>
                <Form.Check disabled={this.isDisabled("Self-assisted")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Self-assisted")} label="Auto-asistido" name="implements" value="Self-assisted" type="checkbox" id="implement-11"/>
                <Form.Check disabled={this.isDisabled("Suspended")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Suspended")} label="Suspendido" name="implements" value="Suspended" type="checkbox" id="implement-12"/>
                <Form.Check disabled={this.isDisabled("Plyometric")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Plyometric")} label="Pliométrico" name="implements" value="Plyometric" type="checkbox" id="implement-13"/>
                <Form.Check disabled={this.isDisabled("Strech")} onChange={this.changeApparatus.bind(this)} checked={0<= this.state.apparatus.indexOf("Strech")} label="Estiramiento" name="implements" value="Strech" type="checkbox" id="implement-14"/>
              </Form>
              <div className={"list"}>
              <p><b>Movimiento</b></p>
                <Form.Check onChange={this.changeMovement.bind(this)} checked={this.state.movement === null} label="Todos" name="movement" value="null" type="radio" id="movement-1"/>
                <Form.Check onChange={this.changeMovement.bind(this)} checked={this.state.movement === "Bilateral"} label="Bilateral" name="movement" value="Bilateral" type="radio" id="movement-2"/>
                <Form.Check onChange={this.changeMovement.bind(this)} checked={this.state.movement === "Unilateral"} label="Unilateral" name="movement" value="Unilateral" type="radio" id="movement-3"/>
                <Form.Check onChange={this.changeMovement.bind(this)} checked={this.state.movement === "Alternating"} label="Alterno" name="movement" value="Alternating" type="radio" id="movement-4"/>
              </div>
              <div className={"list"}>
              <p><b>Utilidad</b></p>
                <Form.Check onChange={this.changeUtility.bind(this)} checked={this.state.utility === null} label="Todos" name="utility" value="null" type="radio" id="utility-1"/>
                <Form.Check onChange={this.changeUtility.bind(this)} checked={this.state.utility === "Auxiliary"} label="Auxiliar" name="utility" value="Auxiliary" type="radio" id="utility-2"/>
                <Form.Check onChange={this.changeUtility.bind(this)} checked={this.state.utility === "Basic"} label="Básico" name="utility" value="Basic" type="radio" id="utility-3"/>
                <Form.Check onChange={this.changeUtility.bind(this)} checked={this.state.utility === "Basic or Auxiliary"} label="Básico o Auxiliar" name="utility" value="Basic or Auxiliary" type="radio" id="utility-4"/>
                <Form.Check onChange={this.changeUtility.bind(this)} checked={this.state.utility === "Power"} label="Fuerza" name="utility" value="Power" type="radio" id="utility-5"/>
                <Form.Check onChange={this.changeUtility.bind(this)} checked={this.state.utility === "Specialized"} label="Especializado" name="utility" value="Specialized" type="radio" id="utility-6"/>
              </div>
            </div>
            <div className="container col-12 col-lg-10" style={{ justifyContent: "center" }}>
              <div style={{display:'flex', flexWrap: 'wrap'}}>
                {this.props.ejercicios ? this.props.ejercicios.map((elemento, index) => (
                    <Ejercicio key={`${elemento.Exercise_Id}-${index}`} ejercicio={elemento} />
                )):null}

                {
                  /* MENSAJE DE FILTRADO NO ENCONTRADO */
                  this.props.ejercicios == null && this.props.musculo !== "" ? (
                      <h4 style={{ textAlign: "center", fontWeight: "normal" }}>
                        No se encontraron ejercicios
                      </h4>
                  ) : null
                }
              </div>

            </div>
          </div>

        </Container>
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  musculo: state.musculo,
  ejercicios: state.ejercicios,
  activePage: state.activePage,
  perpage: state.perpage,
  indexInitial: state.indexInitial,
  indexLast: state.indexLast,
  listRef: state.listRef,
  apparatus: state.apparatus,
});
const mapDispatchToProps = (dispatch) => ({
  handlePageChange(pageNumber, ref) {
    ref.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    dispatch({
      type: "PAGINATION",
      pageNumber: pageNumber,
    });
  },
  selectMusculo(musculo, apparatus, filter) {
    document.getElementById("loading").style.display = "block";
    exerciseService
      .getExercises(filter)
      .then((res) => {
        var exercise = [];
        document.getElementById("loading").style.display = "none";
        for (const key in res.data.exercises) {
          if (Object.hasOwnProperty.call(res.data.exercises, key)) {
            exercise.push(res.data.exercises[key]);
          }
        }
        dispatch({
          type: "SELECT_MUSCULO",
          musculo,
          apparatus,
          ejercicios: exercise.length <= 0?null:exercise,
        });
      })
      .catch((err) => {
        document.getElementById("loading").style.display = "none";
        console.log(err);
      });
  },
  onSearch(musculo, apparatus, filter) {
    document.getElementById("loading").style.display = "block";
    exerciseService
      .getExercises(filter)
      .then((res) => {
        document.getElementById("loading").style.display = "none";
        var exercise = [];
        for (const key in res.data.exercises) {
          if (Object.hasOwnProperty.call(res.data.exercises, key)) {
            exercise.push(res.data.exercises[key]);
          }
        }
        dispatch({
          type: "SELECT_MUSCULO",
          musculo,
          apparatus,
          scroll: true,
          ejercicios: exercise.length <= 0?null:exercise,
        });
      })
      .catch((err) => {
        document.getElementById("loading").style.display = "none";
        console.log(err);
      });
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(Ejercicios);
